import { Story } from '~/types'

export interface PublishErrorProps {
  /**
   * The Editor API generally returns errors of type AppError.
   * Use this prop to make sure the publish actions correctly display
   * the error to the user.
   */
  handleError: (errorKey: string) => void
}

export interface ButtonProps {
  story: Story
}

export enum JobType {
  UNPUBLISH = 'unpublish',
  PUBLISH = 'publish',
}
